import React from "react";
import { ExpandMore, KeyboardArrowRight, ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Checkbox, IconButton } from "@mui/material";

import FlaggedBadge from "../../../../scenes/dashboard/components/genomics-dashboard/components/results/components/variant-table/gpap-table/FlaggedBadge";
import FlagIcon from "@mui/icons-material/Flag";
import getGPAPLabelIcon from "../../../../gpap-lib/icons/GetLabelIcon";


const IndeterminateCheckbox = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = React.useRef();
  const resolvedRef = ref || defaultRef;

  React.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return <Checkbox ref={resolvedRef} {...rest} />;
});

const FlaggedIcon = ({ isFlagged, isCausative, numberTags }) =>
  isFlagged ? (
    <FlaggedBadge badgeContent={numberTags}>
      <FlagIcon sx={{ color: isCausative ? "red" : "#3182bd" }} />
    </FlaggedBadge>
  ) : null;


const useOptionFilter = (columns, type, states, setExpandedRows) => {
  const dataRef = React.useRef(states?.mainData);
  dataRef.current = states?.mainData;

  return (hooks) => {
    hooks.visibleColumns.push((cols) => {
      let newCols = [...cols];

      if (type === "toggle") {
        newCols = [
          {
            id: "selection",
            disableFilters: true,
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          },
          ...newCols
        ];
      }

      // Expansion & tag column 
      if (type === "expanding") {
        newCols = [
          {
            id: "expansion",
            disableFilters: true,
            canSort: true,
            Header: ({ column }) => (
              <div {...column.getSortByToggleProps()}>
                Tag
                {column.isSorted && (
                  <IconButton size="small">
                    {column.isSortedDesc ? <ArrowDownward fontSize="inherit" /> : <ArrowUpward fontSize="inherit" />}
                  </IconButton>
                )}
              </div>
            ),
            sortType: (a, b) => {
              const score = (r) => (r.original.isFlagged ? 1 : 0) + (r.original.labels?.length || 0);
              return score(b) - score(a);
            },
            Cell: ({ row }) => {
              const toggleRow = (e) => {
                e.stopPropagation();
                const newData = dataRef.current[row.original.originalIndex]; 

                setExpandedRows((prev) => ({
                  ...prev,
                  [row.id]: { expanded: true, data: [newData] }
                }));

                states.setRowIdSelected(row.id);
                states.setIdExpanded({ id: row.id, expanded: true });
                row.toggleRowExpanded();
              };

              const ArrowIcon = row.isExpanded ? ExpandMore : KeyboardArrowRight;

              return (
                <span {...row.getToggleRowExpandedProps()} onClick={toggleRow}>
                  <IconButton aria-label="toggle" size="small">
                    <ArrowIcon />
                  </IconButton>

                  <FlaggedIcon
                    isFlagged={row.original.isFlagged}
                    isCausative={row.original.isCausative}
                    numberTags={row.original.numberOfTags}
                  />

                  {row.original.labels?.map((lbl) => (
                    <span key={lbl} style={{width: "24px"}}>{getGPAPLabelIcon(lbl)}</span>
                  ))}
                </span>
              );
            }
          },
          ...newCols
        ];
      }

      return newCols;
    });
  };
};

export default useOptionFilter;